var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    counter: 0,
    isLoaded: false,
};
// example of typed-under-the-hood reducer and simple actions with tools
var rawTestSlice = createSlice({
    name: 'test',
    initialState: initialState,
    reducers: {
        setCounter: function (state, action) {
            state.counter = action.payload;
        },
        setIsLoaded: function (state) {
            state.isLoaded = true;
        },
    },
});
var actions = rawTestSlice.actions;
// example of selectors typings
var getCounter = function (state) { return state.test.counter; };
var incrementCounter = function () { return function (dispatch, getState) {
    var state = getState();
    var counter = getCounter(state);
    return dispatch(actions.setCounter(counter + 1));
}; };
export var testSlice = {
    actions: __assign(__assign({}, actions), { incrementCounter: incrementCounter }),
    selectors: {
        getCounter: getCounter,
    },
};
export default rawTestSlice.reducer;
